/* @ngInject */
const dispatchLabels = () => {
  const self = {}

  self.class = 'Dêpeche'
  self.title = 'Dépêches'

  self.clef = 'Clef'
  self.derangement = 'Dérangement'
  self.gardiennage = 'Gardiennage'
  self.retour = 'Normal'
  self.bening = 'Bening'

  self.fields = {
    id: {
      text: 'Id',
    },
    date: {
      text: 'Date',
    },
    dateBegin: {
      text: 'Le',
    },
    dateEnd: {
      text: 'Jusqu\'au',
    },
    hour: {
      text: 'Heure',
    },
    prg: {
      text: 'PRG',
    },
    sgm: {
      text: 'SGM',
    },
    comment: {
      text: 'Commentaire',
    },
    start: {
      text: 'Départ',
    },
    departure: {
      text: 'Départ',
    },
    delivery: {
      text: 'Livraison',
    },
    tractionnaire: {
      text: 'Tractionnaire',
    },
  }

  self.statements = {
    list: 'Liste des dépêches',
    search: 'Rechercher des dépêches',
    empty: 'Aucune dépêche',
    edit: 'Modifier la dépêche',
    new: 'Nouvelle dépêche',
    defaultComment: 'SGM --> AC BENING\nAutorisation est donnée à la gare de BENING de remettre la clef de l\'aiguillage 89 HBL à l\'agent de desserte ...',
    label: (_size = 0, _point = false) => {
      return 'Dépêche' + (_size > 1 ? 's' : '') + (_point ? ' : ' : '')
    },
    title: (_date, _hour) => {
      return 'Dépêche' + (_date ? ' du ' + _date : '') + (_hour ? ' à ' + _hour : '')
    },
  }

  self.ask = {
    delete: 'Êtes-vous sûr de vouloir supprimer cette dépêche ?',
  }

  self.log = {
    save: {
      success: 'La dépêche a bien été créée.',
      failure: 'Une erreur est survenue lors de la création de la dépêche.',
    },
    update: {
      success: 'La dépêche a bien été modifiée.',
      failure: 'Une erreur est survenue lors de la modification de la dépêche.',
    },
    delete: {
      success: 'La dépêche a bien été supprimée.',
      failure: 'Une erreur est survenue lors de la suppression de la dépêche.',
    },
    search: {
      success: (_length = 0) => {
        if (_length === 0) {
          return 'Aucune dépêche ne correspond à la recherche.'
        } else if (_length === 1) {
          return '1 dépêche a été trouvée.'
        } else if (_length > 1) {
          return _length + ' dépêches ont été trouvées.'
        }
        return 'Dépêche recherchée.'
      },
      failure: 'Une erreur est survenue durant la recherche des dépêches.',
      noResult: 'Aucune dépêche ne correspond à cette recherche',
    },
  }

  return self
}

export default dispatchLabels



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/dispatch/resources/labels.resource.js